import _ from 'underscore';
const throttle = _.throttle;
export default throttle;
